import { c as _c } from "react/compiler-runtime";
import { CarouselDotsPropertiesType } from "@website/ui/carousel/carousel.types";
export const CarouselDots = t0 => {
  const $ = _c(6);
  const {
    currentSlide,
    currentReference,
    keyCarousel
  } = t0;
  let t1;
  if ($[0] !== currentReference?.track?.details?.slides?.length || $[1] !== currentSlide || $[2] !== keyCarousel) {
    t1 = [...Array.from({
      length: currentReference?.track?.details?.slides?.length
    }).keys()]?.map(index => <div className={`size-1.5 rounded-full ${currentSlide === index ? "bg-on-surface-secondary-high-emphasis" : "bg-on-surface-disable-info"}`} key={`${keyCarousel}-dot-${index}`} />);
    $[0] = currentReference?.track?.details?.slides?.length;
    $[1] = currentSlide;
    $[2] = keyCarousel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="bg-on-color-disable z-1 absolute bottom-4 right-1/2 flex translate-x-1/2 gap-1 rounded-full px-2.5 py-1">{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};